var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.9984H24.4009M24.4009 17.9984L18.8007 13.1984M24.4009 17.9984L18.8007 22.7984",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.202 10C13.2213 6.51995 13.3757 4.6353 14.6051 3.40589C16.0111 2 18.2739 2 22.7995 2H24.3996C28.9252 2 31.1882 2 32.594 3.40589C34 4.81178 34 7.07451 34 11.6V24.4C34 28.9254 34 31.1882 32.594 32.5941C31.1882 34 28.9252 34 24.3996 34H22.7995C18.2739 34 16.0111 34 14.6051 32.5941C13.3757 31.3646 13.2213 29.48 13.202 26",
    stroke: "#1C274C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.fd4480b69e81f2054be56252d116aca2.svg";
export { ForwardRef as ReactComponent };